import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import PopupWindow from './PopupWindow.js';
import ErrorBoundary from '@piconetworks/pkg-error-boundary';

var _window, _document;

var capitalize = function capitalize(s) {
  if (typeof s !== 'string') {
    return '';
  }

  return s.charAt(0).toUpperCase() + s.slice(1);
};

var SocialLoginButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SocialLoginButton, _Component);

  function SocialLoginButton(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.openPopup = function (e) {
      var previewMode = _this.props.previewMode;
      e.preventDefault();

      if (previewMode) {
        return;
      }

      _this.setState(function (state) {
        return Object.assign({}, state, {
          popup: true
        });
      });
    };

    _this.closePopup = function () {
      _this.setState(function (state) {
        return Object.assign({}, state, {
          popup: false
        });
      });
    };

    _this.loginResponse = function (authWindow) {
      return function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
            source_origin = _ref.origin,
            data = _ref.data;

        var _this$props = _this.props,
            api_url = _this$props.api_url,
            onLogin = _this$props.onLogin,
            onFailure = _this$props.onFailure,
            type = _this$props.type;
        var popup = _this.state.popup;

        if (source_origin === api_url && popup !== null) {
          var response;

          try {
            response = JSON.parse(data);
          } catch (error) {
            response = JSON.parse(JSON.stringify(data));
          }

          authWindow.close();

          if (response.error) {
            onFailure(response);
          } else {
            onLogin(response, {
              social_type: type
            });
          }
        }
      };
    };

    _this.isFacebookApp = function () {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
    };

    _this.getPopupUrl = function () {
      var _this$props2 = _this.props,
          userId = _this$props2.userId,
          publisherId = _this$props2.publisherId,
          access_token = _this$props2.access_token,
          type = _this$props2.type,
          scope = _this$props2.scope,
          origin = _this$props2.origin,
          referer = _this$props2.referer,
          api_url = _this$props2.api_url,
          utm = _this$props2.utm,
          params = _this$props2.params,
          redirect_uri = _this$props2.redirect_uri;
      var query = Object.assign({}, params, {
        redirect_uri: redirect_uri,
        utm: utm,
        origin: origin,
        client_id: "" + publisherId,
        jwt: access_token,
        user_id: userId,
        referer: referer
      });

      if (_this.isFacebookApp() && !redirect_uri) {
        query.redirect_uri = window.location.ancestorOrigins[0];
      }

      return api_url + "/connect/" + type + "/" + scope + "?" + qs.stringify(query, {
        skipNulls: true
      });
    };

    if (!props.api_url) {
      throw new Error('Invalid api_url');
    }

    _this.state = {
      popup: null,
      response: null
    };
    return _this;
  }

  var _proto = SocialLoginButton.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        children = _this$props3.children,
        type = _this$props3.type,
        content = _this$props3.content,
        button = _this$props3.button,
        previewMode = _this$props3.previewMode,
        _this$props3$onClick = _this$props3.onClick,
        onClick = _this$props3$onClick === void 0 ? function () {} : _this$props3$onClick;
    var popup = this.state.popup;

    var handleClick = function handleClick(e) {
      _this2.openPopup(e);

      onClick();
    };

    var button_component;

    if (button) {
      button_component = /*#__PURE__*/React.cloneElement(button, Object.assign({}, !previewMode && {
        onClick: handleClick
      }));
    } else {
      button_component = /*#__PURE__*/React.createElement("button", {
        onClick: handleClick
      }, content || children);
    }

    return /*#__PURE__*/React.createElement(ErrorBoundary, null, popup && !previewMode && /*#__PURE__*/React.createElement(PopupWindow, {
      url: this.getPopupUrl(),
      title: capitalize(type) + " Login",
      handleResponse: this.loginResponse,
      onClose: this.closePopup
    }), button_component);
  };

  return SocialLoginButton;
}(Component);

SocialLoginButton.propTypes = {
  access_token: PropTypes.string,
  api_url: PropTypes.string.isRequired,
  button: PropTypes.any,
  children: PropTypes.node,

  /** We're trying to deprecate things like content in lieu of children */
  content: PropTypes.string,
  disabled: PropTypes.bool,
  onLogin: PropTypes.func,
  params: PropTypes.shape({
    article_id: PropTypes.string,
    form_id: PropTypes.string,
    newsletter_ids: PropTypes.arrayOf(PropTypes.string),
    custom_fields: PropTypes.object
  }),
  previewMode: PropTypes.bool,
  publisherId: PropTypes.string,
  referer: PropTypes.string,
  origin: PropTypes.string,
  scope: PropTypes.string,
  type: PropTypes.string.isRequired,
  userId: PropTypes.string,
  redirect_uri: PropTypes.string,
  onClick: PropTypes.func,
  utm: PropTypes.shape({
    campaign: PropTypes.string,
    source: PropTypes.string,
    medium: PropTypes.string,
    content: PropTypes.string,
    term: PropTypes.string
  }),
  onFailure: PropTypes.func
};
SocialLoginButton.defaultProps = {
  onFailure: console.error,
  onLogin: console.log,
  previewMode: false,
  disabled: false,
  origin: typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.location.origin),
  referer: typeof document !== 'undefined' && ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer),
  redirect_uri: null,
  access_token: null,
  scope: 'user',
  params: {
    newsletter_ids: []
  },
  utm: {
    campaign: null,
    source: null,
    medium: null,
    content: null,
    term: null
  }
};
SocialLoginButton.displayName = 'SocialLoginButton';

export { SocialLoginButton as default };
//# sourceMappingURL=index.js.map
